import React, { useState, useEffect, memo } from 'react'

//Components.
import ActiveChallengeDetails from '../../../components/challengeDetails/active/ActiveChallengeDetails';
import ChallengeAnnouncementDetails from '../../../components/challengeDetails/annoncements/ChallengeAnnouncementDetails';
import DisplayWinnerComponent from '../../../components/DisplayWinner/DisplayWinnerComponent';
import LoadingChallengeDetails from './loadingChallengeDetails/LoadingChallengeDetails';

//Dependencies.
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

//Images.
import hourGlassImage from "../../../images/hourglass_image.png";

//Slices.
import { allActiveChallenges, allUpcomingChallenges, challengesState } from '../../../slices/challengesSlice';

import './ChallengeDetailsPage.styles.css';

const ChallengeDetailsPage = () => {
  const params = useParams();
  const navigate = useNavigate();
  const activeChallenges = useSelector(allActiveChallenges);
  const upcomingChallenges = useSelector(allUpcomingChallenges);
  const challengesReducer = useSelector(challengesState);
  const dispatch = useDispatch();
  const { _challengeID } = params;
  const currentActiveChallenge = activeChallenges[_challengeID];

  const [loadingStatus, setLoadingStatus] = useState(true);

  useEffect(() => {
    setLoadingStatus(challengesReducer.isLoading);

    return () => {
      
    };
  }, []);

  if (params.type == "announcement") {
    return Object.values(upcomingChallenges).length < 1 ?
      <LoadingChallengeDetails /> //Still loading values from FS to Redux.
      :
      <ChallengeAnnouncementDetails /> //Values loaded to Redux.
  }
  else if (params.type == "active") {
    if (Object.values(activeChallenges).length > 0) {
      const { activeChallengeProperties: { endActiveChallenge }, challengeVideos } = currentActiveChallenge;

      const winningVideo = Object.values(currentActiveChallenge.activeChallengeProperties.winner);

      return (
        <div className='activeChallengeDetailsPage'>
          {
            (endActiveChallenge && (winningVideo.length === 1 && winningVideo[0].winner))
            &&
            <div className='p-0 m-0 displayWinnerContainer'>
              <DisplayWinnerComponent {...winningVideo[0]} />
            </div>
          } {/* If there is a winner */}          
          <div className='p-0 m-0 activeChallengeDetailsContainer'>
            <ActiveChallengeDetails />
          </div>
        </div>
      )
    } else {
      return (
        <div>
          <div style={{ width: '25%', height: '25%' }} className='my-3'>
            <img src={hourGlassImage} alt="hour glass pic" className='img-fluid' />
          </div>
          <h1><em>Please wait as we upload active challenges...</em></h1>
        </div>
      )
    }
  }
  else {
    navigate("/");
    return <></>
  }
}

export default memo(ChallengeDetailsPage);